import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Loader() {
  const [done, setDone] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setDone(true), 1600);
    return () => clearTimeout(t);
  }, []);
  return (
    <AnimatePresence>
      {!done && (
        <motion.div
          initial={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ duration: 0.8 }}
          className="fixed inset-0 z-[999] bg-ink flex items-center justify-center"
          data-testid="loader"
        >
          <div className="flex flex-col items-center gap-6">
            <motion.div
              initial={{ scale: 0.6, opacity: 0 }} animate={{ scale: 1, opacity: 1 }}
              transition={{ duration: 0.9, ease: [0.22,1,0.36,1] }}
              className="wolf-mark gold-foil text-8xl"
            >TS</motion.div>
            <motion.div
              initial={{ width: 0 }} animate={{ width: 200 }} transition={{ duration: 1.2, delay: 0.3 }}
              className="h-px bg-gold"
            />
            <motion.div
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.5 }}
              className="text-hair text-bone/60"
            >The Wolfkeeper</motion.div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
